// extracted by mini-css-extract-plugin
module.exports = {"jackTransferInfoModal":"styles_jackTransferInfoModal__3enm_","content":"styles_content__jpo3o","articleLink":"styles_articleLink__3k0yw","video":"styles_video__2l_mV"};